"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpeningState = exports.ZpdesHssbgGraph = exports.ZpdesHssbg = exports.deepCopy = void 0;
var zpdes_tools_1 = require("./zpdes_tools");
Object.defineProperty(exports, "deepCopy", { enumerable: true, get: function () { return zpdes_tools_1.deepCopy; } });
var zpdes_1 = require("./zpdes");
Object.defineProperty(exports, "ZpdesHssbg", { enumerable: true, get: function () { return __importDefault(zpdes_1).default; } });
var zpdes_graph_1 = require("./zpdes-graph");
Object.defineProperty(exports, "ZpdesHssbgGraph", { enumerable: true, get: function () { return __importDefault(zpdes_graph_1).default; } });
var bm_types_1 = require("./bm.types");
Object.defineProperty(exports, "OpeningState", { enumerable: true, get: function () { return bm_types_1.OpeningState; } });
// If we want 2 versions of ZPDES (one for production and one for test), create two TS files for ZPDES and export both of them
